var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser';
import config from '../../../../config';
var CustomerIoTracker = /** @class */ (function () {
    function CustomerIoTracker() {
        this.enabled = false;
        this.analytics = null;
        try {
            if (config.analytics.CustomerIo.writeKey && config.analytics.CustomerIo.siteId) {
                this.analytics = AnalyticsBrowser.load({ writeKey: config.analytics.CustomerIo.writeKey }, {
                    integrations: {
                        'Customer.io In-App Plugin': {
                            siteId: config.analytics.CustomerIo.siteId,
                        },
                    },
                });
            }
        }
        catch (e) {
            console.error('Error initializing Customer.io', e);
        }
    }
    CustomerIoTracker.prototype.shouldTrack = function () {
        return this.enabled && !!this.analytics;
    };
    CustomerIoTracker.prototype.identify = function (userId, userTraits) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!this.analytics) return [3 /*break*/, 2];
                        this.enabled = true;
                        return [4 /*yield*/, this.analytics.identify(userId, userTraits)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error('Error identifying user in Customer.io', e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CustomerIoTracker.prototype.logOut = function () {
        var _a;
        try {
            this.enabled = false;
            (_a = this.analytics) === null || _a === void 0 ? void 0 : _a.reset();
        }
        catch (e) {
            console.error('Error logging out user in Customer.io', e);
        }
    };
    CustomerIoTracker.prototype.trackPageVisit = function () {
        try {
            if (this.shouldTrack()) {
                this.analytics.page();
            }
        }
        catch (e) {
            console.error('Error tracking page visit in Customer.io', e);
        }
    };
    CustomerIoTracker.prototype.track = function (eventName) {
        try {
            if (this.shouldTrack()) {
                this.analytics.track(eventName);
            }
        }
        catch (e) {
            console.error('Error tracking event in Customer.io', e);
        }
    };
    CustomerIoTracker.getInstance = function () {
        if (CustomerIoTracker.instance === null) {
            CustomerIoTracker.instance = new CustomerIoTracker();
        }
        return CustomerIoTracker.instance;
    };
    return CustomerIoTracker;
}());
export { CustomerIoTracker };
CustomerIoTracker.instance = null;
